export enum appWorkflowStates {
    UNINITIALIZED = -1,
    INIT = 0,
    JUST_AUTHENTICATED_APP_IN_LIMBO = 1,
    AUTHENTICATED = 2,
    UNAUTHENTICATED = 3,
    FORCE_REDIRECT = 4
}